import React from 'react';
import PropTypes from 'prop-types';
import { Slider } from 'antd';

import { rangeSpec } from 'react-jsonschema-form/lib/utils';

class RangeWidget extends React.Component {
  constructor(props) {
    super(props);
    this.initializeDefaultValue();
  }

  initializeDefaultValue() {
    const {
      schema,
      value,
      required,
      onChange,
    } = this.props;
    const specs = rangeSpec(schema);

    if (required && (value === undefined || value === null) && specs.min !== undefined) {
      onChange(specs.min);
    }
  }

  render() {
    const { schema } = this.props;
    const specs = rangeSpec(schema);
    const marks = { [specs.min]: specs.min, [specs.max]: specs.max };
    return (
      <div className="field-range-wrapper">
        <Slider {...this.props} {...rangeSpec(schema)} marks={marks} />
      </div>
    );
  }
}

if (process.env.NODE_ENV !== 'production') {
  RangeWidget.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    schema: PropTypes.object.isRequired,
    registry: PropTypes.object.isRequired,
    required: PropTypes.bool,
    onChange: PropTypes.func,
  };

  RangeWidget.defaultProps = {
    value: undefined,
    required: false,
    onChange: () => {},
  };
}

export default RangeWidget;
